const urls = {
    imageBase: window.location.protocol + '//' + 'backend.borkatalogus.capitalconsulting.hu',
    apiBase: window.location.protocol + '//' + 'backend.borkatalogus.capitalconsulting.hu' + '/api',
};

export default urls;